/* eslint-disable
    no-restricted-syntax,
    functional/prefer-readonly-type
*/
import { Factory } from 'fishery';

import type { DeepPartial } from 'fishery';

type NonEmptyArray<T> = [T, ...T[]];

// Helper type to create a tuple of specific length
type Tuple<T, N extends number, R extends T[] = []> = R['length'] extends N ? R : Tuple<T, N, [T, ...R]>;

function assertNonEmpty<T>(arr: T[]): asserts arr is NonEmptyArray<T> {
    if (arr.length === 0) {
        throw new Error('Expected non-empty array');
    }
}

export class FactoryAutoRewindSequence<
    Item,
    TransientParams = undefined,
    CreateResult = unknown,
    BuildParams = DeepPartial<Item>,
> extends Factory<Item, TransientParams, CreateResult, BuildParams> {
    private buildingList = false;

    override buildList<N extends number>(
        count: N,
        ...args: Parameters<Factory<Item, TransientParams, CreateResult, BuildParams>['buildList']> extends [
            infer _First,
            ...infer Rest,
        ]
            ? Rest
            : never
    ): Tuple<Item, N> {
        if (count <= 0) {
            throw new Error('buildList(0) is not allowed – use at least 1.');
        }
        this.buildingList = true;
        const list = super.buildList(count, ...args);
        this.buildingList = false;

        (this as any).rewindSequence?.();

        assertNonEmpty(list);

        return list as Tuple<Item, N>;
    }

    override build(...args: Parameters<Factory<Item, TransientParams, CreateResult, BuildParams>['build']>): Item {
        const item = super.build(...args);

        if (!this.buildingList) {
            (this as any).rewindSequence?.();
        }

        return item;
    }
}

export function defineAutoRewindFactory<
    Item,
    TransientParams = undefined,
    CreateResult = unknown,
    BuildParams = DeepPartial<Item>,
>(
    initializer: Parameters<typeof Factory.define<Item, TransientParams, CreateResult, BuildParams>>[0],
): FactoryAutoRewindSequence<Item, TransientParams, CreateResult, BuildParams> {
    return FactoryAutoRewindSequence.define<Item, TransientParams, CreateResult, BuildParams>(
        initializer,
    ) as FactoryAutoRewindSequence<Item, TransientParams, CreateResult, BuildParams>;
}
